import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

function gallerySwiper() {
    const gallerySwiperTop = document.querySelector('.gallery__swiper.top');

    if (!gallerySwiperTop) return;

    const swiper = new Swiper(gallerySwiperTop, {
        modules: [Autoplay],
        slidesPerView: 3,
        spaceBetween: 8,
        loop: true,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
        },
        speed: 10000,
        breakpoints: {
            1199: {
                slidesPerView: 4,
                spaceBetween: 24,
            }
        }
    });
    
    const gallerySwiperBottom = document.querySelector('.gallery__swiper.bottom');

    if (!gallerySwiperBottom) return;

    const swiper2 = new Swiper(gallerySwiperBottom, {
        modules: [Autoplay],
        slidesPerView: 3,
        spaceBetween: 8,
        loop: true,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
            reverseDirection: true,
        },
        speed: 20000,
        breakpoints: {
            1199: {
                slidesPerView: 4,
                spaceBetween: 24,
            }
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    gallerySwiper();
})